import React, { useState, useEffect } from "react";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { timesheetApi, Util } from "../../services";
import { DataTable } from "primereact/datatable";
import { Card } from "primereact/card";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { confirmDialog } from "primereact/confirmdialog";
import { useLocation } from "react-router-dom";
import { Editor } from "primereact/editor";
import { Chip } from "primereact/chip";

const CreateTimesheet = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const urlActions = new URLSearchParams(search).get("action");
  const urlDate = new URLSearchParams(search).get("date");
  const [allocatedProjectData, setAllocatedProjectData] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [draftProject, setDraftProject] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedHour, setSelectedHour] = useState("");
  const [mapCategory, setMapCategory] = useState(null);
  const [selectedJiraTaskId, setSelectedJiraTaskId] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [totalDraftHours, setTotalDraftHours] = useState(0);
  const [errorLog, SetErrorLog] = useState(false);
  const [totalHrError, setTotalHrError] = useState(false);
  const [totalHrWarning, setTotalHrWarning] = useState(false);
  const [updatedActivity, setUpdatedActivity] = useState(null);
  const [updatedCategory, setUpdatedCategory] = useState(null);
  // const [startDate, setStartDate] = useState(Util.getMondayOfCurrentWeek(urlActions, urlDate));
  const [startDate, setStartDate] = useState(
    Util.getMondayOfCurrentWeek(urlActions, urlDate),
  );
  const [hoursInputStatus, setHoursInputStatus] = useState(false);

  const [holidays, setHolidays] = useState([]);
  const [allRegions, setAllRegions] = useState([]);
  const [userRegion, setUserRegion] = useState(null);

  const [count, setCount] = React.useState(1000);

  const validateError = () => {
    if (
      !selectedCategory ||
      !selectedActivity ||
      selectedHour === "" ||
      parseFloat(selectedHour) <= 0
    ) {
      SetErrorLog(true);
      return true;
    }
  };
  const ChargeableOrNot = (el) => {
    return el?.isBillable ? (
      <span style={{ color: "green" }}>Chargeable</span>
    ) : (
      <span style={{ color: "red" }}>Non Chargeable</span>
    );
  };

  const formik = useFormik({
    initialValues: {
      timesheetDate: startDate,
      timesheetDescription: "",
      timesheetDays: "",
      totalDraftExceedHours: "",
      totalDraftZeroHours: "",
    },

    validate: (data) => {
      let errors = {};

      //  ESAU: enforce exactly 8 hours at validation time
      /*
      if (userRegion === "ESAU") {
        if (totalDraftHours > 8) {
          errors.totalDraftExceedHours =
            "Total working hours must be exactly 8 hours per day. You have entered more than 8 hours.";
          toast.error(errors.totalDraftExceedHours);
        } else if (totalDraftHours > 0 && totalDraftHours < 8) {
          errors.totalDraftZeroHours =
            "Total working hours must be exactly 8 hours per day. You have entered less than 8 hours.";
          toast.error(errors.totalDraftZeroHours);
        }
      } else if (totalDraftHours > 24) {
        errors.totalDraftExceedHours = "Total hours cannot be more than 24.";
        toast.error(errors.totalDraftExceedHours);
      }
      */
      if (userRegion !== "ESAU" && totalDraftHours > 24) {
        errors.totalDraftExceedHours = "Total hours cannot be more than 24.";
        toast.error(errors.totalDraftExceedHours);
      }

      if (data.timesheetDays > 30) {
        errors.timesheetDays =
          "Timesheet Days should be less than equal to 30 days.";
      }
      if (!data.timesheetDays) {
        errors.timesheetDays = "Days is required.";
      }
      return errors;
    },

    onSubmit: (data) => {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      if (currentUser?.LegalEntity?.code === "ESAU") {
        /*
        if (totalDraftHours !== 8) {
          toast.error("Total hours must be exactly 8 for Australia region.");
          return;
        }
        */
        const hasFullDaySickLeave = draftProject.some((p) =>
          p.projects?.some(
            (item) =>
              item.categoryName === "Leave/PH" &&
              item.activityName === "Sick Leave" &&
              parseFloat(item.hours) === 8,
          ),
        );
        // if (hasFullDaySickLeave) {
        //   toast.error(
        //     "Full day Sick Leave cannot be applied from timesheet. Please apply directly from the Leave Module.",
        //   );
        //   return;
        // }
      }

      if (totalDraftHours > 24) {
        toast.error("Total hours cannot be more than 24.");
        return;
      }
      var projectListing = [];
      for (let i = 0; i < draftProject.length; i++) {
        if (draftProject[i]["projects"]) {
          draftProject[i]["projects"]?.map((item) => {
            let objProject = {
              projectId: item.projectId,
              activityId: item.activityId,
              categoryId: item.categoryId,
              hours: parseFloat(item.hours),
              jiraTaskId: item.jiraTaskId,
              isBillable: item.isBillable,
              description: item.description,
            };
            projectListing.push(objProject);
          });
        }
      }
      let param = {
        date: Util.dateConverter(data.timesheetDate),
        comments: data.timesheetDescription,
        totalDays: data.timesheetDays,
        allocatedProjects: projectListing,
      };
      try {
        timesheetApi.createNewTimesheet(param).then(
          (resp) => {
            toast.info("Timesheet created successfully...");
            navigate("/timesheets");
          },
          (resp) => {
            toast.error(resp.response.data.error);
          },
        );
      } catch (error) {
        toast.error(error?.response?.data?.message ||"Unable to create timesheet...");
      }
      // }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const onCategoryChange = (e) => {
    setSelectedCategory(e.value);
    setSelectedActivity(null);
    if (e.value.code != "LH") {
      setSelectedHour("");
      setHoursInputStatus(false);
    }
  };
  const onActivityChange = (e) => {
    setSelectedActivity(e.value);
    if (e?.value?.code === "Public Holiday") {
      setSelectedHour(8);
      setHoursInputStatus(true);
    } else {
      setSelectedHour("");
      setHoursInputStatus(false);
    }
  };
  const onHourChange = (e) => {
    setSelectedHour(e.target.value);
  };
  const onJiraTaskIdChange = (e) => {
    setSelectedJiraTaskId(e.target.value);
  };
  const onDescriptionChange = (e) => {
    setSelectedDescription(e.target.value);
  };

  useEffect(() => {
    formik.setFieldValue("timesheetDays", 1);
    setTotalHrWarning(false);
    setTotalHrError(false);
    setTotalDraftHours(0);
    fetchAllocatedProjectData();
    getHolidays();
    setStartDate(Util.getMondayOfCurrentWeek(urlActions, urlDate));
    const currentUser = JSON.parse(localStorage.getItem("user"));
    setUserRegion(currentUser?.LegalEntity?.code);
  }, [urlActions]);

  /* get all holidays start*/
  const getHolidays = () => {
    timesheetApi.getAllHolidays().then((resp) => {
      setHolidays(resp.data.h_data);

      //fetch unique region from array
      let regions = [];
      resp.data.h_data?.map((item) => {
        regions.push(item.region);
      });
      let uniqueRegion = Array.from(new Set(regions));
      setAllRegions(uniqueRegion);
    });
  };
  /* get all holidays end*/

  /* Employee/Manager Allocated Project List Start */
  const fetchAllocatedProjectData = (param = {}) => {
    timesheetApi.getAllocatedProject(param).then((resp) => {
      try {
        const activeProjects = resp.data.data.filter((x) => {
          return x.status === 1;
        });
        setDraftProject(activeProjects);
        setAllocatedProjectData(activeProjects);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Employee/Manager Allocated Project List End */

  const changeDate = (e) => {
    formik.setFieldValue("timesheetDate", e.value);
    setStartDate(e.value);
    var dateObj = {
      date: moment(e.value).format("DD-MM-YYYY"),
    };
    try {
      timesheetApi.existingTimesheetCheck(dateObj).then(
        (resp) => {
          if (resp.data.error) toast.error(resp.data.error);
        },
        (err) => {
          toast.error(err);
        },
      );
    } catch (error) {
      toast.error("Unable to create timesheet");
    }
  };

  /*Fetching Holiday List Start*/
  const dateTemplate = (date, e) => {
    let calenderDay = date.day;
    let calenderMonth = date.month + 1;
    let calenderYear = date.year;
    var calenderDateString =
      calenderYear +
      "-" +
      (calenderMonth <= 9 ? "0" + calenderMonth : calenderMonth) +
      "-" +
      (calenderDay <= 9 ? "0" + calenderDay : calenderDay);
    let holiday = {
      indHolDateList: [],
      indHolNameList: [],
      ausHolDateList: [],
      ausHolNameList: [],
      ukHolDateList: [],
      ukHolNameList: [],
      usaDateList: [],
      usaNameList: [],
      singDateList: [],
      singNameList: [],
      canDateList: [],
      canNameList: [],
      phlDateList: [],
      phlNameList: [],
      irlDateList: [],
      irlNameList: [],
    };
    e?.map((x) => {
      switch (x.region) {
        case "IND":
          holiday.indHolDateList.push(x?.date);
          holiday.indHolNameList.push(x?.name);
          break;
        case "AUS":
          holiday.ausHolDateList.push(x?.date);
          holiday.ausHolNameList.push(x?.name);
          break;
        case "UK":
          holiday.ukHolDateList.push(x?.date);
          holiday.ukHolNameList.push(x?.name);
          break;
        case "USA":
          holiday.usaDateList.push(x?.date);
          holiday.usaNameList.push(x?.name);
          break;
        case "SIN":
          holiday.singDateList.push(x?.date);
          holiday.singNameList.push(x?.name);
          break;
        case "PHL":
          holiday.phlDateList.push(x?.date);
          holiday.phlNameList.push(x?.name);
          break;
        case "CAN":
          holiday.canDateList.push(x?.date);
          holiday.canNameList.push(x?.name);
          break;
        case "IRL":
          holiday.irlDateList.push(x?.date);
          holiday.irlNameList.push(x?.name);
          break;
        default:
          holiday.indHolDateList.push(x?.date);
          holiday.indHolNameList.push(x?.name);
      }
    });

    if (holiday.indHolDateList.includes(calenderDateString)) {
      let index = holiday.indHolDateList.findIndex(
        (x) => x == calenderDateString,
      );
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#38bbe6",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.indHolNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    }
    if (holiday.ausHolDateList.includes(calenderDateString)) {
      let index = holiday.ausHolDateList.findIndex(
        (x) => x == calenderDateString,
      );
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#dfe700",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.ausHolNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    }
    if (holiday.ukHolDateList.includes(calenderDateString)) {
      let index = holiday.ukHolDateList.findIndex(
        (x) => x == calenderDateString,
      );
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#86c807",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.ukHolNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    }
    if (holiday.usaDateList.includes(calenderDateString)) {
      let index = holiday.usaDateList.findIndex((x) => x == calenderDateString);
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#e929e9",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.usaNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    }
    if (holiday.singDateList.includes(calenderDateString)) {
      let index = holiday.singDateList.findIndex(
        (x) => x == calenderDateString,
      );
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#a48fef",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.singNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    }
    if (holiday.phlDateList.includes(calenderDateString)) {
      let index = holiday.phlDateList.findIndex((x) => x == calenderDateString);
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#ffa000",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.phlNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    }
    if (holiday.canDateList.includes(calenderDateString)) {
      let index = holiday.canDateList.findIndex((x) => x == calenderDateString);
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#ff6363",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.canNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    }
    if (holiday.irlDateList.includes(calenderDateString)) {
      let index = holiday.irlDateList.findIndex((x) => x == calenderDateString);
      return (
        <>
          <span
            className={"disabled-button_" + date.day}
            style={{
              backgroundColor: "#d3acc4",
              color: "#000000",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "2em",
              height: "2em",
              lineHeight: "2em",
              paddingLeft: calenderDay <= 9 ? "9px" : "5px",
            }}
          >
            {date.day}
            <Tooltip target={".disabled-button_" + date.day}>
              {holiday.irlNameList[index]}
            </Tooltip>
          </span>
        </>
      );
    } else {
      return <span>{date.day}</span>;
    }
  };
  /*Fetching Holiday List End*/

  /* FOR CONFIRMATION DIAGOG BOX */
  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);

  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const confirmDeleteTimesheet = (data, i) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "No",
      rejectLabel: "Yes",
      accept: () => {},
      reject: () => acceptFunc(data, i),
    });
  };

  const acceptFunc = (data, i) => {
    let arr = draftProject[i].projects.filter((obj) => {
      return (
        obj.activityId !== data.activityId ||
        obj.categoryId !== data.categoryId ||
        obj.hours != data.hours
      );
    });
    const draftData = [...draftProject];
    if (draftData[i].hasOwnProperty("projects")) {
      draftData[i].projects = arr;
      draftData[i].totHrs = draftData[i]?.projects.reduce(
        (acc, curr) => acc + parseFloat(curr.hours),
        0,
      );
    }
    let total = 0;
    for (let i = 0; i < draftData.length; i++) {
      total += draftData[i].totHrs ? draftData[i].totHrs : 0;
    }
    if (total > 24) {
      setTotalHrError(true);
      setTotalHrWarning(true);
    } else if (total > 8) {
      setTotalHrWarning(true);
      setTotalHrError(false);
    } else if (total === 0) {
      setTotalHrWarning(false);
      setTotalHrError(true);
    } else {
      setTotalHrWarning(false);
      setTotalHrError(false);
    }
    setTotalDraftHours(total);
    setDraftProject(draftData);
  };

  const saveDraftTimesheet = (index, e) => {
    const error = validateError();
    if (error) {
    } else {
      let activityIsBillable = e.Project.activities.find((item) => {
        return item.id === selectedActivity.id && e.projectId;
      });
      const draftData = [...draftProject];
      const clickedProjectData = {
        projectId: e.projectId,
        categoryId: selectedCategory.id,
        categoryName: selectedCategory.title,
        activityId: selectedActivity.id,
        activityName: selectedActivity.title,
        isBillable: activityIsBillable.isBillable,
        hours: selectedHour,
        jiraTaskId: selectedJiraTaskId,
        description: selectedDescription,
      };
      if (draftData[index].hasOwnProperty("projects")) {
        const isDuplicate = draftData[index].projects.filter((x) => {
          return (
            x.activityId === clickedProjectData.activityId &&
            x.categoryId === clickedProjectData.categoryId
          );
        });
        if (parseFloat(selectedHour) <= 0) {
          toast.error("Hours must be greater than 0");
          return;
        } else if (isDuplicate.length > 0) {
          toast.error("You cannot add duplicate timesheet activity!");
        } else {
          draftData[index]?.projects.push(clickedProjectData);
          draftData[index].totHrs = draftData[index]?.projects.reduce(
            (acc, curr) => acc + parseFloat(curr.hours),
            0,
          );
        }
      } else {
        draftData[index].projects = [clickedProjectData];
        draftData[index].totHrs = draftData[index]?.projects.reduce(
          (acc, curr) => acc + parseFloat(curr.hours),
          0,
        );
      }
      let total = 0;
      for (let i = 0; i < draftData.length; i++) {
        total += draftData[i].totHrs ? draftData[i].totHrs : 0;
      }
      // for ESAU region warn whenever total != 8
      if (userRegion === "ESAU") {
        if (total !== 8 && total > 0) {
          setTotalHrWarning(true);
          setTotalHrError(total > 8);
        } else if (total === 0) {
          setTotalHrWarning(false);
          setTotalHrError(true);
        } else {
          setTotalHrWarning(false);
          setTotalHrError(false);
        }
      } else {
        if (total > 24) {
          setTotalHrWarning(true);
          setTotalHrError(true);
        } else if (total > 8) {
          setTotalHrWarning(true);
          setTotalHrError(false);
        } else if (total === 0) {
          setTotalHrWarning(false);
          setTotalHrError(true);
        } else {
          setTotalHrWarning(false);
          setTotalHrError(false);
        }
      }
      setTotalDraftHours(total);
      setDraftProject(draftData);

      setDisabled(false);
      setSelectedCategory(null);
      setSelectedActivity(null);
      setSelectedHour("");
      setSelectedJiraTaskId("");
      setSelectedDescription("");
      SetErrorLog(false);
    }
  };

  const onRowEditComplete = (e, i) => {
    setUpdatedCategory(null);
    setUpdatedActivity(null);
    let actIsBillable;
     if (!e.newData.hours || parseFloat(e.newData.hours) <= 0) {
      toast.error("Hours must be greater than 0");
      return;
    }
    const _draftProject = [...draftProject[i].projects];
    let { newData, index } = e;
    let actId = newData.activityName.id;
    let actTitle = newData.activityName.title;

    let catId = newData.categoryName.id;
    let catTitle = newData.categoryName.title;
    if (newData.activityName.code === "Public Holiday") {
      setSelectedHour(8);
      setHoursInputStatus(true);
    } else {
      setSelectedHour("");
      setHoursInputStatus(false);
    }
    if (newData.activityName.id === undefined) {
      actIsBillable = e.data.isBillable;
    } else {
      actIsBillable = newData.activityName.isBillable;
    }
    newData["activityId"] = actId ? actId : e.data.activityId;
    newData["activityName"] = actTitle ? actTitle : e.data.activityName;
    newData["isBillable"] = actIsBillable;

    newData["categoryId"] = catId ? catId : e.data.categoryId;
    newData["categoryName"] = catTitle ? catTitle : e.data.categoryName;

    _draftProject[index] = newData;
    const updateDraftData = [...draftProject];
    updateDraftData[i].projects = _draftProject;
    updateDraftData[i].totHrs = updateDraftData[i].projects.reduce(
      (acc, curr) => acc + parseFloat(curr.hours),
      0,
    );

    let total = 0;
    for (let i = 0; i < updateDraftData.length; i++) {
      total += updateDraftData[i].totHrs ? updateDraftData[i].totHrs : 0;
    }
    // for ESAU region warn whenever total != 8
    if (userRegion === "ESAU") {
      if (total !== 8 && total > 0) {
        setTotalHrWarning(true);
        setTotalHrError(total > 8);
      } else if (total === 0) {
        setTotalHrWarning(false);
        setTotalHrError(true);
      } else {
        setTotalHrWarning(false);
        setTotalHrError(false);
      }
    } else {
      if (total > 24) {
        setTotalHrWarning(true);
        setTotalHrError(true);
      } else if (total > 8) {
        setTotalHrWarning(true);
        setTotalHrError(false);
      } else if (total === 0) {
        setTotalHrWarning(false);
        setTotalHrError(true);
      } else {
        setTotalHrWarning(false);
        setTotalHrError(false);
      }
    }
    setTotalDraftHours(total);
    setDraftProject(updateDraftData);
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyPress={Util.preventCharWithMinus}
        maxfractiondigits={2}
        maxLength={5}
        onPaste={Util.preventPasteChar}
      />
    );
  };

  const textDescription = (options) => {
    return (
      <InputTextarea
        style={{ width: "100%" }}
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        rows={1}
        cols={30}
      />
    );
  };
  const textJiraTaskId = (options) => {
    return (
      <InputTextarea
        // style={{ width: "150px" }}
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        rows={1}
        cols={30}
      />
    );
  };

  const changeCategory = (e) => {
    setUpdatedCategory(e);
  };

  const categoryEditor = (options, i) => {
    var userCatList;
    setMapCategory(options.value);
    userCatList = draftProject[i].Project.categories.filter((obj) => {
      return (
        (obj.userId === currentUser.id || obj.userId === null) &&
        obj.status === 1
      );
    });
    let v = userCatList.find((x) => {
      return x.id === options.rowData.categoryId;
    });

    if (updatedCategory) {
      options.value = updatedCategory;
    } else {
      options.value = v;
    }

    return (
      <Dropdown
        value={options.value}
        options={userCatList}
        optionLabel="title"
        onChange={(e) => {
          options.editorCallback(e.value);
          changeCategory(e.value);
        }}
        placeholder="Select Category"
        filter
        // showClear
        filterBy="title"
        itemTemplate={(option) => {
          return <span>{option.title}</span>;
        }}
      />
    );
  };

  const changeActivity = (e) => {
    setUpdatedActivity(e);
  };

  const activityEditor = (options, i) => {
    let userActList;
    // activityList = draftProject.map((el) => {
    userActList = draftProject[i].Project.activities.filter((obj) => {
      if (mapCategory) {
        if (mapCategory?.code == "LH") {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1 &&
            obj.type === "0"
          );
        } else {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1 &&
            obj.type === "1"
          );
        }
      } else {
        return (
          (obj.userId === currentUser.id || obj.userId === null) &&
          obj.status === 1
        );
      }
    });
    let v1 = userActList.find((x) => {
      return x.id === options.rowData.activityId;
    });
    if (updatedActivity) {
      options.value = updatedActivity;
    } else {
      options.value = v1;
    }
    // return userActList;
    // });

    return (
      <Dropdown
        value={options.value}
        options={userActList}
        optionLabel="title"
        onChange={(e) => {
          options.editorCallback(e.value);
          changeActivity(e.value);
        }}
        placeholder="Select Activity"
        filter
        // showClear
        filterBy="title"
        itemTemplate={Util.activityItemBody}
      />
    );
  };

  /* Delete draft timesheet by id start */

  const timesheetDeleteBodyTemplate = (rowData, i) => {
    return (
      <React.Fragment>
        <Button
          type="button"
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger mr-1"
          onClick={() => confirmDeleteTimesheet(rowData, i)}
        />
      </React.Fragment>
    );
  };

  var currentUser = JSON.parse(localStorage.getItem("user"));

  const projectList = draftProject?.map((el, i) => {
    var userCatList = el.Project?.categories?.filter((obj) => {
      return (
        (obj.userId === currentUser.id || obj.userId === null) &&
        obj.status === 1
      );
    });

    var userActList = el.Project?.activities?.filter((obj) => {
      if (selectedCategory) {
        if (selectedCategory?.code == "LH") {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1 &&
            obj.type === "0"
          );
        } else {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1 &&
            obj.type === "1"
          );
        }
      } else {
        return (
          (obj.userId === currentUser.id || obj.userId === null) &&
          obj.status === 1
        );
      }
    });

    return (
      <AccordionTab
        key={i}
        header={
          <div className="grid mt-0" style={{}}>
            <div className="col-10" style={{ float: "left" }}>
              <span>{el.Project.title}</span>
              {el?.isBillable === true ? (
                <span
                  style={{
                    marginLeft: "20px",
                    height: "18px",
                    color: "#c4fec4",
                  }}
                >
                  Billable
                </span>
              ) : (
                <span
                  style={{
                    marginLeft: "20px",
                    height: "18px",
                    color: "#eeaeae",
                  }}
                >
                  Non-Billable
                </span>
              )}
            </div>
            <div className="col-2" style={{ float: "right", textAlign: "end" }}>
              <span>Hours: {el.totHrs ? el.totHrs?.toFixed(2) : 0}</span>
            </div>
          </div>
        }
      >
        <div className="grid">
          <div className="col-fixed" style={{ width: "185px" }}>
            <h5>
              Category <span className="ess-danger">*</span>
            </h5>
            <InputText
              id="timesheetProject"
              name="timesheetProject"
              type="hidden"
              value={el.Project.id}
              maxLength={16}
              disabled
              placeholder="Project"
            />
            <Dropdown
              id="timesheetCategory"
              name="timesheetCategory"
              options={userCatList}
              optionLabel="title"
              placeholder="Select Category"
              value={selectedCategory}
              filter
              filterBy="title"
              onChange={onCategoryChange}
              className={classNames({
                "p-invalid": errorLog && !selectedCategory,
              })}
              appendTo="self"
            />
            {errorLog && (
              <span>
                {selectedCategory === null && (
                  <div className="ess-danger">Select Category!</div>
                )}
              </span>
            )}
          </div>
          <div className="col-fixed" style={{ width: "270px" }}>
            <h5>
              Activity <span className="ess-danger">*</span>
            </h5>
            <Dropdown
              id="timesheetActivity"
              name="timesheetActivity"
              itemTemplate={Util.activityItemBody}
              options={userActList}
              optionLabel="title"
              placeholder="Select Activity"
              filter
              filterBy="title"
              value={selectedActivity}
              onChange={onActivityChange}
              className={classNames({
                "p-invalid": errorLog && !selectedActivity,
              })}
              appendTo="self"
            />
            {errorLog && (
              <span>
                {" "}
                {selectedActivity === null && (
                  <div className="ess-danger">Select Activity!</div>
                )}
              </span>
            )}
          </div>
          <div className="col-fixed" style={{ width: "120px" }}>
            <h5>
              Hours <span className="ess-danger">*</span>
            </h5>
            <InputText
              onKeyPress={Util.preventMinus}
              onPaste={Util.preventPasteChar}
              maxLength={5}
              maxfractiondigits={2}
              id="timesheetHours"
              name="timesheetHours"
              type="text"
              value={selectedHour}
              onChange={onHourChange}
              placeholder="Hours"
              className={classNames({ "p-invalid": errorLog && !selectedHour })}
              disabled={hoursInputStatus}
            />
            {errorLog && (
              <span>
                {selectedHour === "" && (
                  <div className="ess-danger">Enter Hours!</div>
                )}
              </span>
            )}
          </div>
          <div className="col-fixed" style={{ width: "155px" }}>
            <h5>JIRA / Task ID </h5>
            <InputText
              id="timesheetJiraTaskId"
              name="timesheetJiraTaskId"
              value={selectedJiraTaskId}
              onChange={onJiraTaskIdChange}
              placeholder="JIRA / Task ID"
              rows={1}
              cols={30}
            />
          </div>
          <div className="col">
            <h5>Task Description </h5>
            <InputTextarea
              id="description"
              name="description"
              value={selectedDescription}
              onChange={onDescriptionChange}
              rows={1}
              cols={60}
              placeholder="Description"
            />
          </div>
          <div className="col-fixed pt-1" style={{ width: "150px" }}>
            <Button
              type="button"
              label="Add"
              icon="pi pi-plus"
              className="p-button mt-4"
              onClick={(e) => saveDraftTimesheet(i, el)}
            />
          </div>
        </div>

        <div className="ess-table">
          <DataTable
            value={el.projects ? el.projects : []}
            editMode="row"
            dataKey="id"
            onRowEditComplete={(e) => onRowEditComplete(e, i)}
          >
            <Column
              field="categoryName"
              header="Category Name"
              style={{ width: "200px" }}
              editor={(options) => categoryEditor(options, i)}
            ></Column>
            <Column
              field="activityName"
              header="Activity Name"
              style={{ width: "250px" }}
              editor={(options) => activityEditor(options, i)}
            ></Column>
            <Column
              header="Billing Type"
              body={ChargeableOrNot}
              style={{ width: "250px" }}
            ></Column>
            <Column
              field="hours"
              header="Hours"
              editor={(options) => textEditor(options)}
              style={{ width: "150px" }}
            ></Column>
            <Column
              field="jiraTaskId"
              header="JIRA / Task ID"
              editor={(options) => textJiraTaskId(options)}
              style={{ width: "150px" }}
            ></Column>
            <Column
              field="description"
              header="Description"
              editor={(options) => textDescription(options)}
            ></Column>
            <Column
              rowEditor
              header="Edit"
              style={{ width: "90px", textAlign: "center" }}
            ></Column>
            <Column
              field=""
              header="Delete"
              style={{ width: "90px", textAlign: "center" }}
              body={(e) => timesheetDeleteBodyTemplate(e, i)}
            ></Column>
          </DataTable>
        </div>
      </AccordionTab>
    );
  });

  const renderCardHeader = () => {
    return (
      <div className="grid">
        <div className="col">
          <h2 className="p-0 m-0">
            <i className="pi pi-clock pr-1 pl-2" style={{ fontSize: "17px" }} />
            New Timesheet
          </h2>
        </div>
        <div className="col" style={{ textAlign: "right" }}>
          <div
            className="pt-3"
            style={{ display: "inline-block", float: "right" }}
          >
            Total Hours:{" "}
            <strong>{totalDraftHours ? totalDraftHours?.toFixed(2) : 0}</strong>
          </div>
        </div>
        <div className="col-fixed timesheet_button">
          <div className="" style={{}}>
            <label htmlFor="timesheetDate" className=" mr-2">
              Date :{" "}
              <i className="custom-region-btn pi pi-info-circle"></i>{" "}
            </label>
            <Calendar
              id="dateTemplate"
              value={startDate}
              onChange={(e) => changeDate(e)}
              placeholder="Date"
              showIcon
              dateFormat="dd-mm-yy"
              dateTemplate={(e) => dateTemplate(e, holidays)}
            />
            <Button
              label="Back to Timesheets"
              severity="secondary"
              className="ml-1 mt-1"
              onClick={() => navigate("/timesheets")}
            />
            <Tooltip target=".custom-region-btn">
              {allRegions?.map((item, i) => {
                if (item === "IND")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"IND" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#38bbe6",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
                if (item === "AUS")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"AUS" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#dfe700",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
                if (item === "UK")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"UK" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#86c807",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
                if (item === "USA")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"USA" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#e929e9",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
                if (item === "SIN")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"SIN" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#a48fef",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
                if (item === "CAN")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"CAN" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#ff6363",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
                if (item === "PHL")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"PHL" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#ffa000",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
                if (item === "IRL")
                  return (
                    <p style={{ fontWeight: "bold" }} key={"IRL" + i}>
                      {item} :{" "}
                      <span
                        style={{
                          backgroundColor: "#d3acc4",
                          color: "#ffffff",
                          fontWeight: "bold",
                          borderRadius: "50%",
                          width: "2em",
                          height: "2em",
                          lineHeight: "2em",
                          paddingLeft: "20px",
                          marginLeft: "5px",
                        }}
                      ></span>
                    </p>
                  );
              })}
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="ess-page">
      <Card className="ess-headered-card" title={renderCardHeader} style={{}}>
        {totalHrWarning && (
          <div className="ess-message ess-danger pb-2">
            <strong>
              Warning: Recorded hours differ from the defined working hours for
              the day.
            </strong>
          </div>
        )}
        <form
          onSubmit={formik.handleSubmit}
          className="p-grid"
          autoComplete="off"
        >
          <div className="p-fluid accordion-demo">
            <div className="card ess-accordion">
              <Accordion activeIndex={0}>{projectList}</Accordion>
            </div>
            <div className="grid pt-2 mt-4">
              <div className="col" style={{ textAlign: "" }}>
                <h5>Comments(Optional) :</h5>
                <InputTextarea
                  id="timesheetDescription"
                  name="timesheetDescription"
                  value={formik.values.timesheetDescription}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setCount(e.target.value.length);
                  }}
                  rows={3}
                  cols={40}
                  maxLength={1000}
                />
                <span style={{ float: "right" }}>
                  {count === 1000 ? 1000 : 1000 - count} Character(s) Left
                </span>
              </div>
              <div className="col" style={{ textAlign: "right" }}>
                <strong className="pr-2 ml-4">Repeat for</strong>
                <span>
                  <InputText
                    onKeyPress={Util.preventMinus}
                    onPaste={Util.preventPasteChar}
                    id="timesheetDays"
                    name="timesheetDays"
                    type="text"
                    value={formik.values.timesheetDays}
                    onChange={formik.handleChange}
                    style={{ width: "50px" }}
                    maxLength={2}
                    disabled={hoursInputStatus}
                  />
                </span>
                <strong className="pl-2">
                  {formik.values.timesheetDays > 1
                    ? "working days"
                    : "working day"}
                </strong>
                <Button
                  disabled={disabled}
                  type="submit"
                  label="Save & Review"
                  icon="pi pi-save"

                  className="p-button ml-3 mt-3"

                  style={{ width: "158px" }}
                />
                <div>{getFormErrorMessage("timesheetDays")}</div>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default CreateTimesheet;